import { render, staticRenderFns } from "./AcquisitionRateDetail.vue?vue&type=template&id=0d6659b5&"
import script from "./AcquisitionRateDetail.vue?vue&type=script&lang=js&"
export * from "./AcquisitionRateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports